<!-- StepFinalReport.vue -->
<template>
  <div class="modal_final">
    <div class="modal_main_inputs_head">
      Ваш отчет готов!
    </div>
    
    <div class="modal_final_content">
      <!-- Левая колонка -->
      <div class="modal_final_left">
        <!-- Блок 1: Тип документа (статический) -->
        <div class="info-block">
          <div class="info-block-header">
            <div class="info-block-title">Тип документа</div>
            <div class="info-block-status">Регламент</div>
          </div>
          <div class="info-block-description">
            Документ успешно распознан как регламент
          </div>
        </div>

        <!-- Блок 2: Найденные разделы -->
        <div class="info-block" v-if="sections.length">
          <div class="info-block-title">Найденные разделы</div>
          <div class="sections-list">
            <div v-for="(section, index) in sections" :key="index" class="section-item">
              <span class="section-icon">
                <svg v-if="checklist[index + 1]" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6L9 17L4 12" stroke="#00ff00" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span v-else class="section-icon-false">✕</span>
              </span>
              <span class="section-name">{{ section }}</span>
            </div>
          </div>
        </div>

        <!-- Блок 3: Стоимость процесса -->
        <div class="info-block" v-if="hasEstimation">
          <div class="info-block-title">Стоимость процесса</div>
          <div class="cost-grid">
            <div class="cost-item">
              <div class="cost-label">Стоимость одной единицы</div>
              <div class="cost-value">{{ formatCost(estimation.cost_per_unit) }} ₽</div>
            </div>
            <div class="cost-item">
              <div class="cost-label">Годовой объем затрат</div>
              <div class="cost-value">{{ formatCost(estimation.cost_per_unit * (parseInt(quantity) || 0)) }} ₽</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Правая колонка -->
      <div class="modal_final_right">
        <!-- Блок 4: Продукт процесса -->
        <div class="info-block">
          <div class="info-block-title">Продукт процесса</div>
          <div class="product-info">
            <div class="product-name">{{ product }}</div>
            <div class="product-quantity">{{ quantity }} единиц в год</div>
          </div>
          <div class="product-note">
            Lazarus автоматически определил продукт на основе анализа регламента
          </div>
        </div>

        <!-- Блок 5: Сводка по ролям -->
        <div class="info-block" v-if="roles.length">
          <div class="info-block-title">Сводка по ролям</div>
          <div class="roles-list">
            <div v-for="(role, index) in roles" :key="index" class="role-item">
              <div class="role-name">{{ role.name }}</div>
              <div class="role-details">{{ role.count }} чел. × {{ formatCost(role.cost) }} ₽/час</div>
            </div>
          </div>
        </div>

        <!-- Блок с ценой отчета -->
        <div class="price-block">
          <div class="price-header">
            <div class="price-title">Стоимость отчета</div>
            <div class="price-value">{{ price }}</div>
            <div class="price-description">{{ priceDescription }}</div>
          </div>
          <div class="price-features">
            <div v-for="(item, index) in finalItems" :key="index" class="price-feature">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#8A75FF" stroke-width="2">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Кнопки действий -->
    <div class="modal_final_actions">
      <div class="modal_main_load_content_btn restart-btn" @click="$emit('restart')">
        <span>Начать сначала</span>
      </div>
    </div>

    <!-- Блок с email и скачиванием -->
    <div class="download-section">
      <div class="download-title">Укажите email для получения отчета</div>
      
      <!-- Показываем форму только если нет ссылки -->
      <template v-if="!reportUrl">
        <div class="download-form">
          <input 
            type="email" 
            v-model="email" 
            @input="validateEmail"
            placeholder="Введите ваш email"
            class="email-input"
            :class="{ 'invalid': !isEmailValid && email !== '' }"
          />
          
          <div class="modal_main_load_content_btn download-btn" 
     @click.prevent.stop="handleDownload"
     :class="{ 'disabled': !isEmailValid || isDownloading }"
     style="cursor: pointer;">
     
            <span v-if="isDownloading">Отправка...</span>
            <span v-else>Получить ссылку</span>
          </div>
        </div>
        <div v-if="emailError" class="error-message">{{ emailError }}</div>
      </template>
      
      <!-- Показываем кнопку-ссылку когда ссылка получена -->
      <div v-else class="download-result">
        <a :href="reportUrl" target="_blank" class="modal_main_load_content_btn download-btn success">
          Скачать отчет
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepFinalReport',
  props: {
    taskId: {
      type: String,
      default: ''
    },
    sections: {
      type: Array,
      default: () => []
    },
    checklist: {
      type: Object,
      default: () => ({})
    },
    estimation: {
      type: Object,
      default: () => ({
        cost_per_unit: 0,
        time_per_unit_hours: 0,
        total_roles_involved: 0,
        total_annual_cost: 0
      })
    },
    hasEstimation: {
      type: Boolean,
      default: false
    },
    product: {
      type: String,
      default: ''
    },
    quantity: {
      type: [String, Number],
      default: '0'
    },
    roles: {
      type: Array,
      default: () => []
    },
    finalItems: {
      type: Array,
      default: () => [
        'Полный аудит регламента',
        'Анализ структуры документа',
        'Расчет стоимости процесса',
        'Рекомендации по улучшению'
      ]
    },
    price: {
      type: String,
      default: 'Free'
    },
    priceDescription: {
      type: String,
      default: 'Единоразовая плата'
    }
  },
  emits: ['restart', 'download', 'share', 'save'],
  data() {
    return {
      email: '',
      isEmailValid: false,
      isDownloading: false,
      emailError: '',
      reportUrl: null
    }
  },
  methods: {
    formatCost(value) {
      const num = parseInt(value) || 0
      return new Intl.NumberFormat('ru-RU').format(num)
    },
    
    validateEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      this.isEmailValid = emailRegex.test(this.email)
      this.emailError = ''
    },
    
    async handleDownload(event) {
  // Жестко запрещаем всё
  if (event) {
    event.preventDefault()
    event.stopPropagation()
  }
  
  // Принудительно оставляем скролл на месте
  const scrollX = window.scrollX
  const scrollY = window.scrollY
  
  if (this.reportUrl) {
    return
  }
  
  if (!this.isEmailValid || this.isDownloading || !this.taskId) return
  
  this.isDownloading = true
  this.emailError = ''
  
  try {
    const contactResponse = await fetch(`${this.$parent?.ApiLink || ''}/api/v1/tasks/contacts`, {
      method: 'POST',
      headers: {
        'accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        task_id: this.taskId,
        email: this.email,
        tg_id: "",
        username: "",
        first_name: "",
        last_name: ""
      })
    })
    
    if (!contactResponse.ok) {
      throw new Error('Ошибка при отправке email')
    }
    
    // Задержка 5 секунд для второго сценария
    if (this.$options.name === 'StepComparisonFinalReport') {
      await new Promise(resolve => setTimeout(resolve, 5000))
    }
    
    this.reportUrl = `${this.$parent?.ApiLink || ''}/api/v1/tasks/${this.taskId}/report`

    
    // Возвращаем скролл на место

    
  } catch (error) {
    console.error('Ошибка:', error)
    this.emailError = 'Не удалось получить ссылку. Попробуйте позже.'
  } finally {
    this.isDownloading = false
  }
},
  }
}
</script>

<style scoped>
.modal_main_inputs_head {
  text-align: start;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 600;
}

.modal_final_content {
  display: flex;
  gap: 24px;
  width: 100%;
}

.modal_final_left,
.modal_final_right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-block {
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
  padding: 20px;
}

.info-block-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.info-block-title {
  font-size: 16px;
  font-weight: 600;
  color: #8A75FF;
  margin-bottom: 16px;
  text-align: start;
}

.info-block-status {
  background: #00aa0020;
  color: #00ff00;
  border: 1px solid #00ff00;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 14px;
}

.info-block-description {
  color: #888;
  font-size: 14px;
  line-height: 1.5;
  text-align: start;
}

.sections-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.section-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-icon-false {
  color: #ff6b6b;
  font-size: 18px;
  font-weight: bold;
}

.section-name {
  color: #fff;
  font-size: 14px;
}

.cost-grid {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cost-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #403F6D;
}

.cost-item:last-child {
  border-bottom: none;
}

.cost-label {
  color: #888;
  font-size: 14px;
}

.cost-value {
  color: #8A75FF;
  font-size: 18px;
  font-weight: 600;
}

.product-info {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.product-name {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 4px;
  text-align: start;
}

.product-quantity {
  color: #888;
  font-size: 14px;
}

.product-note {
  color: #666;
  font-size: 12px;
  padding-top: 8px;
  border-top: 1px solid #403F6D;
}

.roles-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.role-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #403F6D;
}

.role-item:last-child {
  border-bottom: none;
}

.role-name {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.role-details {
  color: #8A75FF;
  font-size: 14px;
}

.price-block {
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
  overflow: hidden;
}

.price-header {
  background: #8A75FF20;
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #403F6D;
}

.price-title {
  color: #888;
  font-size: 14px;
  margin-bottom: 8px;
}

.price-value {
  color: #8A75FF;
  font-size: 36px;
  font-weight: 700;
  margin-bottom: 4px;
}

.price-description {
  color: #8A75FF;
  font-size: 12px;
}

.price-features {
  padding: 20px;
}

.price-feature {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  color: #fff;
  font-size: 14px;
}

.price-feature svg {
  flex-shrink: 0;
}

.modal_final_actions {
  margin-top: 24px;
}

.modal_main_load_content_btn {
  display: flex;
  gap: 8px;
  padding: 18px 40px;
  background: #8A75FF;
  justify-content: center;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.3s;
  width: 100%;
}

.modal_main_load_content_btn:hover {
  opacity: 0.9;
}

.download-section {
  margin-top: 32px;
  padding: 24px;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 16px;
}

.download-title {
  font-size: 18px;
  font-weight: 600;
  color: #8A75FF;
  margin-bottom: 16px;
  text-align: start;
}

.download-form {
  display: flex;
  gap: 16px;
  align-items: center;
}

.email-input {
  flex: 1;
  background: #ffffff0a;
  border: 1px solid #403F6D;
  border-radius: 12px;
  padding: 16px 20px;
  color: #fff;
  font-size: 16px;
  transition: all 0.3s;
}

.email-input:focus {
  outline: none;
  border-color: #8A75FF;
  background: #ffffff15;
}

.email-input.invalid {
  border-color: #ff6b6b;
}

.email-input::placeholder {
  color: #666;
}

.download-btn {
  width: auto;
  min-width: 200px;
  padding: 16px 32px;
}

.download-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.download-link {
  margin-top: 12px;
  text-align: start;
}

.report-link {
  color: #8A75FF;
  text-decoration: underline;
  font-size: 14px;
  cursor: pointer;
}

.report-link:hover {
  opacity: 0.8;
}

.error-message {
  color: #ff6b6b;
  font-size: 14px;
  margin-top: 8px;
  text-align: start;
}

@media (max-width: 1024px) {
  .modal_final_content {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .download-form {
    flex-direction: column;
  }
  
  .download-btn {
    width: 100%;
  }
}

@media (max-width: 580px) {
  .cost-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .role-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.download-result {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}

.download-btn.success {
  background: #00aa00;
  min-width: 200px;
  text-decoration: none;
  color: white;
  width: 100%;
}

.download-btn.success:hover {
  background: #00cc00;
}
</style>